ㄖ<template>
  <span
    :class="['icon', 'icon-' + name]"
    v-html="html"/>
</template>

<script>
export default {
  props: [
    'name'
  ],

  computed: {
    html () {
      return `
        <svg>
          <use xlink:href="#icon-${this.name}"/>
        </svg>
      `
    }
  }
}

// In Chrome console，how to get none rectangle icon's real width
// window.__getSVGIconsWidth = () => {
//   return [].slice.call(document.querySelectorAll('symbol')).map((symbol) => {
//     let rect = symbol.viewBox.animVal
//     return rect.width === rect.height ? '' : `
//       .${symbol.id} {
//         width: ${rect.width}em / ${rect.height};
//       }
//     `
//   }).join('')
// }
</script>



// WEBPACK FOOTER //
// src/components/icon.vue